import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { isEmpty } from "lodash";
import Box from "@material-ui/core/Box";

import ProfilesResults from "../GlobalSearch/ProfilesResults";
import colors from "../../assets/style/colors";

const styles = {
  tableContainer: {
    maxWidth: 860,
    maxHeight: "calc(100vh - 160px)",
    zIndex: 1000,
    overflow: "auto",
    borderRadius: "4px",
    backgroundColor: colors.white,
    boxShadow: `0px 2px 9px 2px ${colors.black23}`,
  },
  noResultsFound: {
    height: 50,
    width: 300,
    color: colors.black54,
    padding: 12,
    display: "flex",
    alignItems: "center",
  },
};

const ProfilesSearchResults = (props) => {
  const { classes, profiles, searchValue, language, isFetching } = props;

  return (
    <Box className={classes.tableContainer} style={props.style}>
      {isEmpty(profiles) && !isFetching ? (
        <Box className={classes.noResultsFound}>
          {I18n.get("profiles_noResultsFound")}
        </Box>
      ) : (
        <ProfilesResults
          profiles={profiles}
          searchValue={searchValue}
          language={language}
        />
      )}
    </Box>
  );
};

export default withStyles(styles)(ProfilesSearchResults);
